import { render, staticRenderFns } from "./BurdenFileList.vue?vue&type=template&id=49e37f26&scoped=true&"
import script from "./BurdenFileList.vue?vue&type=script&lang=js&"
export * from "./BurdenFileList.vue?vue&type=script&lang=js&"
import style0 from "./BurdenFileList.vue?vue&type=style&index=0&id=49e37f26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e37f26",
  null
  
)

export default component.exports